import axios from 'axios'
import {AuthModel} from '../models/AuthModel'
import {UserModel} from '../models/UserModel'
import jwt from 'jwt-decode'
//import { setAccessToken } from '../../../../_metronic/partials/widgets/store/AuthSlice'
import {actions} from './AuthRedux'
//import {store} from '../../../../_metronic/partials/widgets/store/Store'
import store from '../../../../setup/redux/Store'
import {identityApiUrl} from '../../../../setup/appConfig'
const API_URL = process.env.REACT_APP_API_URL || 'api'
const refreshAxios = axios.create()
const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/get-user`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot-password`
// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, {email, password})
}

export async function login2(email: string, password: string) {
  const response = await fetch(`${identityApiUrl}/Users/Identity`, {
    credentials: 'include',
    headers: {Accept: 'application/json', ClientId: clientId},
  })
  const data = await response.json()
  if (data) {
    localStorage.setItem('accessToken', data.accessToken)
    localStorage.setItem('refreshToken', data.refreshToken)
    store.dispatch(actions.setAccessToken(data.accessToken))
    const authModel: AuthModel = {
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      roles: data.roles,
    }

    return authModel
  }

  return {}
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {email})
}

export function getUserByToken23() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}

export function getUserByToken(accessToken: any) {
  const decoded: any = jwt(accessToken || '')
  const tmpData: UserModel = {
    id: 1,
    firstname: decoded.username,
    lastname: '',
    password: undefined,
    username: decoded.username,
    email: decoded.email,
    pic: decoded.photoUrl,
  }

  return tmpData
}
export async function getUserFromIdentity() {
  try {
    const response: any = await axios({
      method: 'get',
      withCredentials: true,
      url: `${identityApiUrl}/users/identity`,
    })
    localStorage.setItem('accessToken', response.data.accessToken)
    localStorage.setItem('refreshToken', response.data.refreshToken)
    store.dispatch(actions.setAccessToken(response.data.accessToken))
    return await response.data
  } catch {
    return {accessToken: null}
  }
}

export function isTokenExpired(accessToken: string): boolean {
  try {
    const decoded: any = jwt(accessToken)

    if (!decoded.exp) {
      return true
    }

    // exp je u sekundama
    let condition = decoded.exp * 1000 < Date.now()
    return decoded.exp * 1000 < Date.now()
  } catch {
    return true
  }
}
export async function refreshAccessToken() {
  try {
    const accessToken = localStorage.getItem('accessToken')
    const refreshToken = localStorage.getItem('refreshToken')

    const response: any = await refreshAxios.post(
      `${identityApiUrl}/UserSessions/Refresh`,
      {
        accessToken: accessToken,
        refreshToken: refreshToken,
      },
      {
        withCredentials: true,
        headers: {
          ClientId: clientId,
          Authorization: accessToken,
        },
      }
    )

    // opcionalno: update tokena nakon refresh-a
    if (response.data?.accessToken) {
      localStorage.setItem('accessToken', response.data.accessToken)
      store.dispatch(actions.setAccessToken(response.data.accessToken))
    }

    if (response.data?.refreshToken) {
      localStorage.setItem('refreshToken', response.data.refreshToken)
    }

    return response.data
  } catch (error) {
    console.error('Refresh token failed', error)

    return null
  }
}
